<template>
  <div class="form-element">
    <label class="form-element__title"
    v-if="title">{{ title }}</label>
    <input
      v-numeric="'iban'"
      class="form-element__input -iban"
      type="text"
      placeholder="TR__ ____ ____ ____ ____ ____ __"
      :name="title"
      :class="classObject"
      maxlength="32"
      autocomplete="off"
      @keyup="changed"
    
      @blur="changed"
      v-model.trim="val"
    />
     <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message"
    >
      {{ message }}
    </div>

    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message2"
      style="color:red"
    >
      {{ message2 }}
    </div>
  </div>
  
</template>

<script>
import { numeric } from "@/directives/";
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
     message2: {
      type: String,
      default: null,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    isQuarter: {
      type: Boolean,
      default: false,
    },
     isError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classObject: function() {
      let list = {
        "-half": this.isHalf,
        "-quarter": this.isQuarter,
         "-error": this.isError,
      };

      return list;
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  watch: {
    value: function() {
      // console.log("val >>", val);
      // this.val = val;
    },
  },
  directives: { numeric },
  methods: {
    changed: function(e) {
      let val = e.target.value;

      if (e.target.value == "T" || e.target.value == "TR") {
        val = null;
        this.val = null;
      }

      this.$emit("input", val);
      return val;
    },
  },
};
</script>
